/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

import { OAuth2Providers } from 'shared';

import { Namespaces } from '../../i18n';
import { ssoIcons } from './components/SsoProviderIcons/SsoProviderIcons';
import { ssoLinks } from './SsoProviderButton.consts';

type SsoProviderButtonProps = {
  provider: OAuth2Providers;
};

export const SsoProviderButton = memo<SsoProviderButtonProps>(props => {
  const { provider } = props;
  const { t } = useTranslation();

  return (
    <Button fullWidth variant="outlined" title={provider} href={ssoLinks[provider]} startIcon={ssoIcons[provider]}>
      {t(`${Namespaces.Login}:page.login.continue_with_button`, {
        name: provider,
      })}
    </Button>
  );
});
